// extracted by mini-css-extract-plugin
module.exports = {"socials":"Vd60T05z","spaceFix":"_1VU4h5uF","outline":"_2b-zEgbA","socialButtonField":"_2a3tUUNA","loginIcon":"_3_zdI0HB","facebook":"xhdn0Usl","twitter":"_2ZPAifps"};